import ListProcesses from "@/views/agro_exporter/production/query_container_quality/ListProcesses.vue";
import ShowProcess from "@/views/agro_exporter/production/query_container_quality/ShowProcess.vue";
import ShowProcessContainers from "@/components/views/agro_exporter/production/query_container_quality/show_process/Containers.vue"
import ShowProcessGraphics from "@/components/views/agro_exporter/production/query_container_quality/show_process/Graphics.vue"
import ShowContainer from "@/views/agro_exporter/production/query_container_quality/ShowContainer.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "ae",
  role: "production",
  permission: "query_container_quality"
});

export default [
  {
    path: "/ae/:agro_exporter_id/production/query_container_quality/list_processes",
    name: routeName(""),
    redirect: { name: routeName("list_processes") }
  },
  {
    path: "/ae/:agro_exporter_id/production/query_container_quality/list_processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/production/query_container_quality/show_process/:agro_exporter_process_id",
    name: routeName("show_process"),
    component: ShowProcess,
    redirect: { name: routeName("show_process_containers") },
    props: true,
    meta: META,
    children: [
      {
        path: "containers",
        name: routeName("show_process_containers"),
        component: ShowProcessContainers,
        props: true
      },
      {
        path: "graphics",
        name: routeName("show_process_graphics"),
        component: ShowProcessGraphics,
        props: true
      }
    ]
  },
  {
    path: "/ae/:agro_exporter_id/production/query_container_quality/show_container/:agro_exporter_process_id/:container_id",
    name: routeName("show_container"),
    component: ShowContainer,
    props: true,
    meta: META
  }
]
